/**
 * Sets up FreshChat widget
 * @param {String} username username from settings
 * @param {String} station station_name from settings
 */
export const setupFreshChatWidget = (username, station) => {
  const updateFcWidget = () => {
    window.fcWidget.user.setProperties({
      firstName: username,
      station,
    }).catch(e => console.log(e));

    window.fcWidget.setExternalId(`${station}-${username}`).catch(e => console.log(e));
  };

  const initFreshChat = () => {
    if (window.fcWidget) {
      window.fcWidget.init({
        token: '4856173b-0f88-4ef7-abfe-b57e784771cd',
        host: 'https://wchat.freshchat.com',
        config: {
          headerProperty: {
            backgroundColor: '#c9db34',
            foregroundColor: '#000',
          },
          content: {
            headers: {
              chat: 'Chat With VIP Support',
            },
          },
        },
      });

      window.fcWidget.user.get().then(({ success, data }) => {
        if (success && data && (!data.firstName || !data.identifier)) {
          // not all necessary settings are configured, so set them
          updateFcWidget();
        }
      }).catch(() => {
        // user doesn't exist in fc, so tell it who the user is
        updateFcWidget();
      });
    } else {
      console.warn('fcWidget window object not loaded');
    }
  };

  const scriptEl = document.createElement('script');
  scriptEl.defer = 'defer';
  scriptEl.src = 'https://wchat.freshchat.com/js/widget.js';
  scriptEl.onload = initFreshChat;
  document.head.appendChild(scriptEl);
};



// WEBPACK FOOTER //
// ./src/core/util.js